import adjustButtonStyle from "./adjustButtonStyle.js";
import { sideBySideIcon, minimapIcon } from "./resources/Icons.js";
const av = Autodesk.Viewing;
const avu = av.UI;

const GlobalManagerMixin = av.GlobalManagerMixin;

export default class MinimapSideBySideButton {
    constructor(parent) {
        this.parent = parent;
        this.parentElement = parent.mapWidgetHeader;
        this.setGlobalManager(parent.viewer.globalManager);
        // Create toggle to switch between small map and side-by-side map
        this.sideBySideButton = new avu.Button("Minimap_SideBySide");
        this.sideBySideButton.setGlobalManager(this.globalManager);
        this.sideBySideButton.onClick = () =>
            parent.minimap3DExtension.setSideBySideEnabled(!parent.sideBySideEnabled);
        this.sideBySideButton.icon.innerHTML = sideBySideIcon;
        this.sideBySideButton.icon.style.width = "20px";
        this.sideBySideButton.icon.style.height = "20px";
        this.parentElement.appendChild(this.sideBySideButton.container);

        // Create alternative icon that we show in side-by-side mode
        const _document = this.getDocument();
        this.shrinkIcon = _document.createElement("div");
        this.shrinkIcon.innerHTML = minimapIcon;
        this.shrinkIcon.style.width = "20px";
        this.shrinkIcon.style.height = "20px";
        this.sideBySideButton.container.appendChild(this.shrinkIcon);

        adjustButtonStyle(this.sideBySideButton, true);

        // Set icons and tooltips
        this.update();
    }

    setSideBySideButtonDisabled(disable) {
        this.sideBySideButtonDisabled = disable;
    }

    update() {
        const sideBySideIsEnabled = this.parent.sideBySideEnabled;
        // Show expand/collapse icon depending on current state
        this.shrinkIcon.style.display = sideBySideIsEnabled ? "block" : "none";
        this.sideBySideButton.icon.style.display = sideBySideIsEnabled
            ? "none"
            : "block";

        this.sideBySideButton.setState(
            this.sideBySideButtonDisabled
                ? avu.Button.State.DISABLED
                : avu.Button.State.INACTIVE
        );

        // Set tooltips based on current states
        const SideBySide = Autodesk.Viewing.i18n.translate("Side by side");
        const Minimap = Autodesk.Viewing.i18n.translate("Small map");
        this.sideBySideButton.setToolTip(sideBySideIsEnabled ? Minimap : SideBySide);
    }

    dtor() {
        this.parentElement.removeChild(this.sideBySideButton.container);
        this.sideBySideButton = null;
        this.shrinkIcon = null;
    }
}

GlobalManagerMixin.call(MinimapSideBySideButton.prototype);
